export const trace_options = {
  alpha_threshold: 50,
  ltres: 2,
  qtres: 3,
  pathomit: 10,
  linefilter: true,
  rightangleenhance: true,
  colorquantcycles: 1,
  viewbox: true,
  roundcoords: 1,
  palette: [{ r: 255, g: 255, b: 255, a: 255 }],
};

export const pathscan_combined_lookup = [
  [
    [-1, -1, -1, -1],
    [-1, -1, -1, -1],
    [-1, -1, -1, -1],
    [-1, -1, -1, -1],
  ], // arr[py][px]===0 is invalid
  [
    [0, 1, 0, -1],
    [-1, -1, -1, -1],
    [-1, -1, -1, -1],
    [0, 2, -1, 0],
  ],
  [
    [-1, -1, -1, -1],
    [-1, -1, -1, -1],
    [0, 1, 0, -1],
    [0, 0, 1, 0],
  ],
  [
    [0, 0, 1, 0],
    [-1, -1, -1, -1],
    [0, 2, -1, 0],
    [-1, -1, -1, -1],
  ],

  [
    [-1, -1, -1, -1],
    [0, 0, 1, 0],
    [0, 3, 0, 1],
    [-1, -1, -1, -1],
  ],
  [
    [13, 3, 0, 1],
    [13, 2, -1, 0],
    [7, 1, 0, -1],
    [7, 0, 1, 0],
  ],
  [
    [-1, -1, -1, -1],
    [0, 1, 0, -1],
    [-1, -1, -1, -1],
    [0, 3, 0, 1],
  ],
  [
    [0, 3, 0, 1],
    [0, 2, -1, 0],
    [-1, -1, -1, -1],
    [-1, -1, -1, -1],
  ],

  [
    [0, 3, 0, 1],
    [0, 2, -1, 0],
    [-1, -1, -1, -1],
    [-1, -1, -1, -1],
  ],
  [
    [-1, -1, -1, -1],
    [0, 1, 0, -1],
    [-1, -1, -1, -1],
    [0, 3, 0, 1],
  ],
  [
    [11, 1, 0, -1],
    [14, 0, 1, 0],
    [14, 3, 0, 1],
    [11, 2, -1, 0],
  ],
  [
    [-1, -1, -1, -1],
    [0, 0, 1, 0],
    [0, 3, 0, 1],
    [-1, -1, -1, -1],
  ],

  [
    [0, 0, 1, 0],
    [-1, -1, -1, -1],
    [0, 2, -1, 0],
    [-1, -1, -1, -1],
  ],
  [
    [-1, -1, -1, -1],
    [-1, -1, -1, -1],
    [0, 1, 0, -1],
    [0, 0, 1, 0],
  ],
  [
    [0, 1, 0, -1],
    [-1, -1, -1, -1],
    [-1, -1, -1, -1],
    [0, 2, -1, 0],
  ],
  [
    [-1, -1, -1, -1],
    [-1, -1, -1, -1],
    [-1, -1, -1, -1],
    [-1, -1, -1, -1],
  ], // arr[py][px] === 15 is invalid
];

export const SIMPLIFY_OPT = {
  tolerance: 2.5,
  density: 10,
  segments: 300,
};
